import { Injectable } from '@angular/core';
import { WSResponseModel } from '../classes/WSResponseModel';
import { environment } from 'src/environments/environment';
import { Observable, firstValueFrom } from 'rxjs';
import { LoginModel } from '../classes/LoginModel';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DataDoc } from '../classes/doc-data.model';
import { DataDocAge } from '../classes/doc-age-data.model';

@Injectable({
	providedIn: 'root'
})
export class DocsService {
	cliente!: LoginModel;

	constructor(
		private http: HttpClient,
		private toastrService: ToastrService) {
	}

	//Funzione di login che richiama il web service
	async fetchOrdWeb(idUtente: number, daData: string = '', aData: string = '', stato: number = -1): Promise<DataDoc> {
		const httpOptions = {
			headers: {
				idUtente: idUtente.toString()
			}
		};

		let endpoint = `OrdWeb/ListOrdWeb?stato=${stato}`;
		if (daData != "") {
			endpoint += "&daData=" + daData
		}
		if (aData != "") {
			endpoint += "&aData=" + aData
		}

		const url = `${environment.backend.baseURL}/${endpoint}`;

		try {
			const response = await firstValueFrom(this.http.get<WSResponseModel>(url, httpOptions));
			const parsedResponse = JSON.parse(response!.jsonlist);
			return parsedResponse;
		} catch (error) {
			console.log('error: ' + error.toString());
			if (error.status) {
				switch (error.status) {
					case 400: {
						this.toastrService.error(error.error.info);
						break;
					}
					default: {
						this.toastrService.error(error.message);
					}
				}
			} else {
				this.toastrService.error(error.message);
			}
			throw error; // Rilancia l'errore per la gestione successiva
		}
	}


	// fetchOrdWeb(idUtente: number, daData: string = '', aData: string = ''): Observable<WSResponseModel> {
	// 	const httpOptions = {
	// 		headers: {
	// 			idUtente: idUtente.toString()
	// 		}
	// 	};

	// 	let endpoint = 'OrdWeb/GetOrdWebList?';
	// 	if (daData != "") {
	// 		endpoint += "daData=" + daData
	// 	}
	// 	if (aData != "") {
	// 		endpoint += "&aData=" + aData
	// 	}

	// 	const url = `${environment.backend.baseURL}/${endpoint}`;

	// 	return this.http.get<WSResponseModel>(url, httpOptions);
	// }

	// fetchOrdCli(COD_CF: string, daData: string = '', aData: string = ''): Observable<WSResponseModel> {
	// 	const httpOptions = {
	// 		headers: {
	// 			COD_CF: COD_CF
	// 		}
	// 	};

	// 	let endpoint = 'OrdCli/ListOrdCli?';
	// 	if (daData != "") {
	// 		endpoint += "daData=" + daData
	// 	}
	// 	if (aData != "") {
	// 		endpoint += "&aData=" + aData
	// 	}
	// 	const url = `${environment.backend.baseURL}/${endpoint}`;

	// 	return this.http.get<WSResponseModel>(url, httpOptions);
	// }

	async loadDocStepData(docId: string) {
		const temp = `OrdWeb/GetOrdWebTracking?docId=${docId}`;

		return await firstValueFrom(this.http.get(`${environment.backend.baseURL}/${temp}`))
			.then((result: any) => {
				let list = JSON.parse(result!.jsonlist)

				return list;
			})
			.catch(
				error => {
					console.log('error: ' + error.toString())
					if (error.status) {
						switch (error.status) {
							case 400: {
								this.toastrService.error(error.error.info);
								break;
							}
							default: {
								this.toastrService.error(error.message);
							}
						}
					} else {
						this.toastrService.error(error.message);
					}
				}
			);
	 }



	async fetchOrdAge(
		COD_CF: string,
		COD_AGE1_CLI: string,
		COD_AGE2_CLI: string,
		daData: string = '',
		aData: string = '',
		DOC_ID: string = '',
		RAG_SOC_CF: string = '',
		FLAG_EVASO: string = '',
		SITUAZIONE_ORDINE: string = ''
		): Promise<DataDocAge> {
		
		const httpOptions = {
			headers: {
				COD_CF: COD_CF.toString(),
				COD_AGE1_CLI: COD_AGE1_CLI,
				COD_AGE2_CLI: COD_AGE2_CLI
			}
		};

		let endpoint = `OrdCli/ListOrdAge?`;
		if (daData !== "") {
			endpoint += "daData=" + daData;
		}
		if (aData !== "") {
			// Aggiungi il carattere "&" solo se ci sono già parametri nella stringa endpoint
			endpoint += (endpoint.includes("?") ? "&" : "") + "aData=" + aData;
		}


		var body = { 
			DOC_ID: DOC_ID, 
			RAG_SOC_CF: RAG_SOC_CF,
			FLAG_EVASO: FLAG_EVASO,
			SITUAZIONE_ORDINE: SITUAZIONE_ORDINE }

		const url = `${environment.backend.baseURL}/${endpoint}`;

		try {
			const response = await firstValueFrom(this.http.post<WSResponseModel>(url, body, httpOptions));
			const parsedResponse = JSON.parse(response!.jsonlist);
			return parsedResponse;
		} catch (error) {
			//console.log('error: ' + error.toString());
			if (error.status) {
				switch (error.status) {
					case 400: {
						this.toastrService.error(error.error.info);
						break;
					}
					default: {
						this.toastrService.error(error.message);
					}
				}
			} else {
				this.toastrService.error(error.message);
			}
			throw error; // Rilancia l'errore per la gestione successiva
		}
	}
}